import { Pipe, PipeTransform } from '@angular/core';
import { formatDate, DateInput } from '../utils/date-format.util';

@Pipe({ name: 'appFormatDate', standalone: true })
export class AppFormatDatePipe implements PipeTransform {
  transform(value: DateInput, fallback = '—'): string {
    return formatDate(value, fallback);
  }
}
